import React, { useState, useEffect } from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    Button,
    Spinner
} from 'reactstrap';
import MaterialTable from 'material-table';

// Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

//Components
import DocumentoFicha from './DocumentoFicha';
import documento_api from '../../../api/documento_api.js';
import { showMessage } from 'helpers/message.js';

export default function DocumentoLista() {
    //Estado de controle do loading na tela
    const [show_loading, set_show_loading] = useState(false);

    //Estado de controle da lista de documentos
    const [documentos, set_documentos] = useState([]);

    //Estado de controle do clique do botão adicionar
    const [adicionar, set_adicionar] = useState(false);

    //Estado de controle de edição do documento
    const [editar, set_editar] = useState(null);

    //Função de visualização dos dados do documento selecionado
    const handleVisualizar = (rowData) => {
        set_editar(rowData.documento_Id);
    }

    //Função que carrega a lista de documentos
    const loadDocumentos = () => {
        set_show_loading(true);
        documento_api.getAll().then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
                return;
            }
            set_documentos(response.data);
        }).finally(f => set_show_loading(false));
    }

    useEffect(() => {
        loadDocumentos();
    }, []);

    if (adicionar || editar)
        return <DocumentoFicha id={editar} btnVoltar={() => {
            set_adicionar(false);
            set_editar(null);
            loadDocumentos();
        }} />
    return (
        <div className={"content"}>
            {show_loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Card>
                <CardHeader className="d-flex align-items-center justify-content-between">
                    <h4 className="titleCard mb-0">Lista de Documentos</h4>
                    <Button color={"success"} onClick={() => set_adicionar(true)}>+ Adicionar</Button>
                </CardHeader>
                <CardBody>
                    <MaterialTable style={{ minHeight: "auto" }}
                        title=""
                        columns={[
                            { title: 'Identificação', field: 'identificacao' },
                            { title: 'Status', field: 'status' },
                        ]}
                        data={documentos}
                        isLoading={false}
                        options={{
                            ...table_style,
                            filtering: false,
                            exportButton: true
                        }}
                        actions={[
                            {
                                icon: 'search',
                                tooltip: 'Visualizar Registro',
                                onClick: (event, rowData) => handleVisualizar(rowData)
                            }
                        ]}
                        localization={table_translate}
                    />
                </CardBody>
            </Card>
        </div >
    )
}